import { api } from "@/lib/api-client";

export interface OutputsCatalogRow {
  destinationId: string;
  name: string;
  jobTypeId: string;
  jobTypeName: string;
  adapterType: string;
  target: string;
  formatName: string | null;
  isPrimary: boolean;
  isActive: boolean;
  lastSuccessAt: string | null;
  lastError: { at: string; message: string } | null;
}

export function fetchOutputsCatalog(): Promise<OutputsCatalogRow[]> {
  return api.get<OutputsCatalogRow[]>("/export-destinations/catalog");
}
